const data = { abuseData: [{"rank":1,"name":"LeBron James","sport":"BasketBall","count":122568,"category":"all"},
{"rank":2,"name":"Marcus Rashford","sport":"Soccer","count":32328,"category":"all"},
{"rank":3,"name":"Tom Brady","sport":"American Football","count":28151,"category":"all"},
{"rank":4,"name":"Kevin Durant","sport":"Basketball","count":24370,"category":"all"},
{"rank":5,"name":"Bubba Wallace","sport":"NASCAR","count":21750,"category":"all"},
{"rank":6,"name":"Damian Lillard","sport":"Basketball","count":20904,"category":"all"},
{"rank":7,"name":"Trevor Bauer","sport":"Baseball","count":14083,"category":"all"},
{"rank":8,"name":"Cristiano Ronaldo","sport":"Soccer","count":11757,"category":"all"},
{"rank":9,"name":"Stephen Curry","sport":"Basketball","count":11203,"category":"all"},
{"rank":10,"name":"Mesut Ozil","sport":"Soccer","count":11192,"category":"all"},
{"rank":11,"name":"JuJu Smith Schuster","sport":"American Football","count":10164,"category":"all"},
{"rank":12,"name":"Dez Bryant","sport":"American Football","count":10163,"category":"all"},
{"rank":13,"name":"Stan Collymore","sport":"Soccer","count":9659,"category":"all"},
{"rank":14,"name":"Deshaun Watson","sport":"American Football","count":9293,"category":"all"},
{"rank":15,"name":"James Harden","sport":"Basketball","count":9220,"category":"all"},
{"rank":16,"name":"Michael Thomas","sport":"American Football","count":8051,"category":"all"},
{"rank":17,"name":"Kyrie Irving","sport":"Basketball","count":7860,"category":"all"},
{"rank":18,"name":"Lamar Jackson","sport":"American Football","count":7856,"category":"all"},
{"rank":19,"name":"Odell Beckham Jr","sport":"American Football","count":7451,"category":"all"},
{"rank":20,"name":"Paul Pogba","sport":"Soccer","count":7349,"category":"all"},
{"rank":1,"name":"LeBron James","sport":"Basketball","count":1628,"category":"homophobic"},
{"rank":2,"name":"Neymar Jr","sport":"Soccer","count":1217,"category":"homophobic"},
{"rank":3,"name":"Cristiano Ronaldo","sport":"Soccer","count":920,"category":"homophobic"},
{"rank":4,"name":"Megan Rapinoe","sport":"Soccer","count":800,"category":"homophobic"},
{"rank":5,"name":"Justin Thomas","sport":"Golf","count":709,"category":"homophobic"},
{"rank":6,"name":"Kevin Durant","sport":"Basketball","count":462,"category":"homophobic"},
{"rank":7,"name":"Marcus Rashford","sport":"Soccer","count":460,"category":"homophobic"},
{"rank":8,"name":"Sue Bird","sport":"Basketball","count":435,"category":"homophobic"},
{"rank":9,"name":"Bubba Wallace","sport":"NASCAR","count":386,"category":"homophobic"},
{"rank":10,"name":"Tom Brady","sport":"American Football","count":346,"category":"homophobic"},
{"rank":11,"name":"Stephen Curry","sport":"Basketball","count":142,"category":"homophobic"},
{"rank":12,"name":"Damian Lillard","sport":"Basketball","count":138,"category":"homophobic"},
{"rank":13,"name":"Ian Wright","sport":"Soccer","count":134,"category":"homophobic"},
{"rank":14,"name":"Paul Pogba","sport":"Soccer","count":122,"category":"homophobic"},
{"rank":15,"name":"Mesut Ozil","sport":"Soccer","count":108,"category":"homophobic"},
{"rank":16,"name":"Stan Collymore","sport":"Soccer","count":104,"category":"homophobic"},
{"rank":17,"name":"Trevor Bauer","sport":"Baseball","count":100,"category":"homophobic"},
{"rank":18,"name":"JuJu Smith Schuster","sport":"American Football","count":99,"category":"homophobic"},
{"rank":19,"name":"Mo Salah","sport":"Soccer","count":97,"category":"homophobic"},
{"rank":20,"name":"Kylian Mbappe","sport":"Soccer","count":97,"category":"homophobic"},

],
            }

export default data;
